import { queriesNotifications } from "@query";
import { tokenStore } from "@services/tokenStore";

export function removeNotificationFromCache(notificationId: string) {
  const personId = tokenStore.getIdentity()?.personId;
  if (!personId) return;

  const request = { personId };
  const current = queriesNotifications.listNotifications.getQueryData(request);
  if (!current) return;

  queriesNotifications.listNotifications.setQueryData(request, {
    ...current,
    data: current.data?.filter(
      notification => notification.id !== notificationId
    )
  });
}
